import { Zap, Brain, Coins } from 'lucide-react';

/**
 * Three Challenges at Scale
 *
 * Standalone section for the landing page.
 * Shows the three core GPU inference challenges + agility statement.
 */

const challenges = [
    {
        icon: Zap,
        label: 'Low Latency',
        problem: 'Cold starts kill user experience',
        solution: 'Predictive scaling & pre-warming',
    },
    {
        icon: Brain,
        label: 'High Utilization',
        problem: 'GPUs sit idle 60-80% of the time',
        solution: 'Higher utilization via intelligent batching & routing',
    },
    {
        icon: Coins,
        label: 'Cost Efficiency',
        problem: 'Premium hardware, basic tasks',
        solution: 'Right workload, right resource',
    },
];

export const InferenceChallenges = () => {
    return (
        <section className="py-20 md:py-28 px-4 sm:px-6 bg-obsidian-900">
            <div className="max-w-5xl mx-auto">
                {/* Header */}
                <div className="text-center mb-8">
                    <h3 className="text-2xl font-bold text-white mb-2">Three Challenges at Scale</h3>
                    <p className="text-gray-400">Optimizing one is easy. Balancing all three at scale is the hard part.</p>
                </div>

                {/* Three challenges */}
                <div className="grid md:grid-cols-3 gap-6">
                    {challenges.map((item, i) => (
                        <div key={i} className="p-6 rounded-xl bg-white/[0.02] border border-white/[0.06]">
                            <div className="w-10 h-10 rounded-lg flex items-center justify-center bg-volt-500/10 mb-3">
                                <item.icon className="w-5 h-5 text-volt-400" />
                            </div>
                            <div className="text-lg font-semibold text-white mb-2">{item.label}</div>
                            <div className="text-sm text-red-400/80 mb-3">{item.problem}</div>
                            <div className="text-sm text-volt-400">{'\u2192'} {item.solution}</div>
                        </div>
                    ))}
                </div>

                {/* Bottom insight - Agility statement */}
                <div className="mt-8 p-6 rounded-xl bg-gradient-to-r from-volt-500/10 via-volt-500/5 to-transparent border border-volt-500/20 text-center">
                    <p className="text-2xl lg:text-3xl font-bold text-white mb-2">
                        Agility is the new currency.
                    </p>
                    <p className="text-gray-400 max-w-2xl mx-auto">
                        The GPU economy is shifting from scarcity to dynamic arbitrage.
                        The winners aren{'\u2019'}t those with the most GPUs {'\u2014'} they{'\u2019'}re the ones who use them best.
                    </p>
                </div>
            </div>
        </section>
    );
};
